import gql from 'graphql-tag';

// 定形文マスタ取得
export const GET_TEMPLATE = gql`
    query(
        $template_code: String!
    ){
        GetTemplate(
            template_code: $template_code
        ){
            id
            golf_group_code
            template_code
            template_name
            template
            valid_flag
        }
    },
`;
